<!-- 个人中心 > 列表组件 -->
<template>
  <div class="userCenterTable" :class="{tableBorder: !isGray }">
    <el-table
      v-loading="isShowLoading"
      :data="tableData ? tableData : []"
      :class="{garyTable: isGray }"
      border
      highlight-current-row
      :row-style="{height: '40px'}"
      :header-cell-style="{background: isGray ? '#EAEAEA' : '#FFA06D', color: isGray ? '#333333' : '#ffffff', fontSize: '18px', fontWeight: '400'}"
    >
      <!--序号栏-->
      <el-table-column align="center" label="序号" width="58">
        <template slot-scope="scope" align="center">
          {{ scope.$index+1 }}
        </template>
      </el-table-column>
      <template v-for="item in fieldData">
        <el-table-column align="center" :label="item.label" :prop="item.field" :width="item.width">
          <template slot-scope="scope">
            <template v-if="item.type === 'text'">
              {{ scope.row[item.field] }}
            </template>
            <template v-else-if="item.type === 'status'">
              <el-tag effect="plain" :style="{cursor: item.statusOption[scope.row[item.field]] && item.statusOption[scope.row[item.field]].isClick ? 'pointer' : ''}"  :class="item.statusOption[scope.row[item.field]] ? item.statusOption[scope.row[item.field]].className: ''" @click="handleClick(item.statusOption[scope.row[item.field]].isClick,scope.row)">{{ item.statusOption[scope.row[item.field]] ? item.statusOption[scope.row[item.field]].label: '' }}</el-tag>
            </template>
            <template v-else>
              <slot :name="item.field" :data="scope.row" />
            </template>
          </template>
        </el-table-column>
      </template>
    </el-table>
    <el-pagination
      background
      align="left"
      style="margin: 20px"
      :class="isGray ? 'homePagePagination' : 'otherPagePagination'"
      layout="total, sizes, prev, pager, next, jumper"
      :current-page="pageNumber"
      :page-sizes="[5, 10, 20, 30, 50]"
      :page-size="pageSize"
      :total="totalCount"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
  </div>
</template>

<script>
export default {
  name: 'UserCenterTable',
  props: {
    fieldData: {
      type: Array,
      required: true
    },
    tableData: {
      type: Array,
      required: true
    },
    isShowLoading: {
      type: Boolean,
      required: true
    },
    totalCount: {
      type: Number,
      required: true
    },
    pageNumber: {
      type: Number,
      required: true
    },
    pageSize: {
      type: Number,
      required: true
    },
    isGray: {
      type: Boolean,
      defaultValue: false
    }
  },
  methods: {
    handleClick(flag, rowData) {
      if (flag) {
        this.$emit('handleClick', rowData)
      }
    },
    handleSizeChange(val) {
      this.$emit('handleSizeChange',val)
    },
    handleCurrentChange(val) {
      this.$emit('handleCurrentChange',val)
    }
  }
}
</script>

<style lang="scss" scoped>
.userCenterTable {
  margin-top: 15px;
  overflow: hidden;
}
.tableBorder {
  min-height: 720px;
  border-radius: 3px;
  border: 1px solid #DBDBDB;
}
</style>
